import { useEffect, useRef } from 'react'

import TagCloud from 'TagCloud'

import { skills } from '../../data/portfolio'

export default function WordCloud() {
  const container = useRef(null)
  useEffect(() => {
    const element = container.current
    const render = () => {
      const radius = Math.min(300, Math.max(110, element.parentElement.clientWidth / 2 - 15))
      return TagCloud(element, skills, { radius, maxSpeed: 'fast', initSpeed: 'fast', direction: 135, keep: true })
    }
    let cloud = render()
    const resize = () => { cloud.destroy(); cloud = render() }
    window.addEventListener('resize', resize)
    return () => { window.removeEventListener('resize', resize); cloud.destroy() }
  }, [])
  return <div className="main" aria-label="Technical skills"><div ref={container} className="content" /></div>
}
